import axios from "axios";
import i18n from "../../../i18n";
import { orderType } from "../../ui-library/CustomTable/constants";

// Constants
const SET_FAVORITE_MEALS = "SET_FAVORITE_MEALS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getFavoriteMeals = (state) => state?.favoriteMeals;

// Default state
const initialState = {
  favoriteMeals: [],
};

export const favoriteMealsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FAVORITE_MEALS:
      const { meals } = action;
      return {
        ...state,
        favoriteMeals: meals,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchFavoriteMeals = () => (dispatch) => {
  const params = {
    page: 0,
    limit: 10000,
    search: "",
    orderBy: "date",
    order: orderType.DESC,
  };

  return axios
    .get(`/api/diet/meals/favorites`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_FAVORITE_MEALS,
        meals: parseTableData(data.data),
      });
    })
    .catch(() => {
      return Promise.reject(i18n.t("errorText.dietDiary.favorites.get"));
    });
};

const parseTableData = (data) => {
  const formattedData = [];
  if (data) {
    data.forEach((elem) => {
      const { name, mealJson, key, createdAt } = elem;

      const favoriteObj = {
        name: name,
        json: mealJson,
        dateTime: createdAt,
        favoriteId: key,
      };

      formattedData.push(favoriteObj);
    });
  }

  return formattedData;
};

export const mapStateToProps = (state) => {
  return {
    favoriteMeals: getFavoriteMeals(state),
  };
};

export const mapDispatchToProps = {
  fetchFavoriteMeals,
  resetState,
};
